import React, { useContext } from 'react'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { IconButton } from '@material-ui/core'
import { QlikUIContext } from '../../QlikUIContext';
import { Script } from '../Script';
import { Style } from '../Style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons'

export const WidgetConfig = ({templateElementId, onEndConfiguration }) => {

    const context = useContext(QlikUIContext);

    let jQueryLoaded = window.jQuery !== undefined;
    let bootstrapLoaded = jQueryLoaded;
    if (jQueryLoaded) {
        bootstrapLoaded = typeof($.fn.dropdown) !== 'undefined';
    }
    let zoneLoaded = window.Zone !== undefined;

    return (
        <React.Fragment>
            {
                <div>
                    <Style src={context.fontAwesomeCssPath} />

                    <Script src={`${context.widgetConfigPath}assets/DragDropTouch.js`} async={false} />

                    <Script src={`${context.widgetConfigPath}inline.bundle.js`} async={false} />

                    {
                        !jQueryLoaded && <Script src={context.jQueryPath} async={false} />
                    }

                    {
                        !bootstrapLoaded && <Script src={context.bootstrapJsPath} async={false} />
                    }

                    {
                        !zoneLoaded && <Script src={`${context.widgetConfigPath}polyfills.bundle.js`} async={false} />
                    }

                    <Style src={`${context.widgetConfigPath}styles.bundle.css`} />
                    <Script src={`${context.widgetConfigPath}vendor.bundle.js`} async={false} />
                    <Script src={`${context.widgetConfigPath}main.bundle.js`} async={false} />
                    <Style src={context.bootstrapCssPath} />

                    <Grid container direction="row" justify="space-around">
                        <Grid item xs={12} sm={6}>
                            <Typography variant="h6" component="div" color="initial">
                                Configuración elementos de plantilla
                            </Typography>
                        </Grid>
                        <Grid container item xs={12} sm={6} spacing={3} direction="row" justify="flex-end" alignItems="center">
                            <Grid item xs={1}>
                                <IconButton aria-label="Volver" onClick={onEndConfiguration} size="small" title="Volver">
                                    <FontAwesomeIcon icon={faArrowCircleLeft} fixedWidth />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>

                    <base href="" />
                    <app-root id={templateElementId} 
                        security-token={context.securityToken} 
                        subscription={context.subscription} 
                        api-endpoint={context.conceptApiEndpoint}></app-root>
                </div>
            }
        </React.Fragment>
    );
}